var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMutation } from "react-query";
import { queryClient } from "frontend/src/domain/query-client";
import { deleteTrack, updateTrack, publishTracks, unpublishTracks, updateTracks, deleteTracks, refreshTrackDurations, } from "frontend/src/api/tracks";
import { notify } from "frontend/src/features/notifications";
import { cacheKey } from "./shared";
export var useUpdateTrack = function () {
    var _a = useMutation(updateTrack, {
        onMutate: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(cacheKey)];
                    case 1:
                        _a.sent();
                        // return queryClient.getQueryData<TrackPreview[]>(cacheKey); // TODO: add optimistic update
                        return [2 /*return*/, queryClient.getQueryData(cacheKey)]; // TODO: add optimistic update
                }
            });
        }); },
        onError: function (_, __, context) {
            queryClient.setQueryData(cacheKey, context);
            notify({
                variant: "error",
                message: "При обновлении трека произошла ошибка.",
            });
        },
        onSuccess: function () {
            notify({ variant: "success", message: "Изменения сохранены." });
        },
        onSettled: function () {
            queryClient.invalidateQueries(cacheKey);
        },
    }), mutate = _a.mutate, isLoading = _a.isLoading, isSuccess = _a.isSuccess, data = _a.data;
    return {
        data: data,
        do: function (track) { return mutate(track); },
        isLoading: isLoading,
        isSuccess: isSuccess,
    };
};
export var useUpdateTracks = function () {
    var _a = useMutation(updateTracks, {
        onMutate: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(cacheKey)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, queryClient.getQueryData(cacheKey)]; // TODO: add optimistic update
                }
            });
        }); },
        onError: function (_, __, context) {
            queryClient.setQueryData(cacheKey, context);
            notify({
                variant: "error",
                message: "При обновлении треков произошла ошибка.",
            });
        },
        onSuccess: function () {
            notify({ variant: "success", message: "Изменения сохранены." });
        },
        onSettled: function () {
            queryClient.invalidateQueries(cacheKey);
        },
    }), mutate = _a.mutate, isLoading = _a.isLoading, isSuccess = _a.isSuccess, data = _a.data;
    return {
        data: data,
        do: function (tracks) { return mutate(tracks); },
        isLoading: isLoading,
        isSuccess: isSuccess,
    };
};
export var useDeleteTrack = function () {
    var _a = useMutation(deleteTrack, {
        onMutate: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(cacheKey)];
                    case 1:
                        _a.sent();
                        // return queryClient.getQueryData<TrackPreview[]>(cacheKey); // TODO: add optimistic update
                        return [2 /*return*/, queryClient.getQueryData(cacheKey)]; // TODO: add optimistic update
                }
            });
        }); },
        onError: function (_, __, context) {
            queryClient.setQueryData(cacheKey, context);
            notify({
                variant: "error",
                message: "При удалении трека произошла ошибка.",
            });
        },
        onSuccess: function () {
            notify({ variant: "success", message: "Трек удалён." });
        },
        onSettled: function () {
            queryClient.invalidateQueries(cacheKey);
        },
    }), mutate = _a.mutate, isLoading = _a.isLoading, isSuccess = _a.isSuccess, data = _a.data;
    return {
        data: data,
        do: function (id) { return mutate(id); },
        isLoading: isLoading,
        isSuccess: isSuccess,
    };
};
export var useDeleteTracks = function () {
    var _a = useMutation(deleteTracks, {
        onMutate: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(cacheKey)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, queryClient.getQueryData(cacheKey)]; // TODO: add optimistic update
                }
            });
        }); },
        onError: function (_, __, context) {
            queryClient.setQueryData(cacheKey, context);
            notify({
                variant: "error",
                message: "При удалении треков произошла ошибка.",
            });
        },
        onSuccess: function () {
            notify({ variant: "success", message: "Треки удалёны." });
        },
        onSettled: function () {
            queryClient.invalidateQueries(cacheKey);
        },
    }), mutate = _a.mutate, isLoading = _a.isLoading, isSuccess = _a.isSuccess, data = _a.data;
    return {
        data: data,
        do: function (ids) { return mutate(ids); },
        isLoading: isLoading,
        isSuccess: isSuccess,
    };
};
export var usePublishTracks = function () {
    var _a = useMutation(publishTracks, {
        onMutate: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(cacheKey)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, queryClient.getQueryData(cacheKey)]; // TODO: add optimistic update
                }
            });
        }); },
        onError: function (_, __, context) {
            queryClient.setQueryData(cacheKey, context);
            notify({
                variant: "error",
                message: "При публикации треков произошла ошибка.",
            });
        },
        onSuccess: function () {
            notify({ variant: "success", message: "Треки опубликованы." });
        },
        onSettled: function () {
            queryClient.invalidateQueries(cacheKey);
        },
    }), mutate = _a.mutate, isLoading = _a.isLoading, isSuccess = _a.isSuccess, data = _a.data;
    return {
        data: data,
        do: function (ids) { return mutate({ tracksIds: ids }); },
        isLoading: isLoading,
        isSuccess: isSuccess,
    };
};
export var useUnpublishTracks = function () {
    var _a = useMutation(unpublishTracks, {
        onMutate: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(cacheKey)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, queryClient.getQueryData(cacheKey)]; // TODO: add optimistic update
                }
            });
        }); },
        onError: function (_, __, context) {
            queryClient.setQueryData(cacheKey, context);
            notify({
                variant: "error",
                message: "При снятии треков с публикации произошла ошибка.",
            });
        },
        onSuccess: function () {
            notify({ variant: "success", message: "Треки сняты с публикации." });
        },
        onSettled: function () {
            queryClient.invalidateQueries(cacheKey);
        },
    }), mutate = _a.mutate, isLoading = _a.isLoading, isSuccess = _a.isSuccess, data = _a.data;
    return {
        data: data,
        do: function (ids) { return mutate({ tracksIds: ids }); },
        isLoading: isLoading,
        isSuccess: isSuccess,
    };
};
export var useRefreshTrackDurations = function () {
    var _a = useMutation(refreshTrackDurations, {
        onMutate: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(cacheKey)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, queryClient.getQueryData(cacheKey)];
                }
            });
        }); },
        onError: function (_, __, context) {
            queryClient.setQueryData(cacheKey, context);
            notify({
                variant: "error",
                message: "При пересчёте длительности произошла ошибка.",
            });
        },
        onSuccess: function (result) {
            notify({
                variant: "success",
                message: "\u0414\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u043F\u0435\u0440\u0435\u0441\u0447\u0438\u0442\u0430\u043D\u0430: \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u043E " + result.updated + ", \u043E\u0448\u0438\u0431\u043E\u043A " + result.failed + ".",
            });
        },
        onSettled: function () {
            queryClient.invalidateQueries(cacheKey);
        },
    }), mutate = _a.mutate, isLoading = _a.isLoading, isSuccess = _a.isSuccess, data = _a.data;
    return {
        data: data,
        do: function (ids) { return mutate({ tracksIds: ids }); },
        isLoading: isLoading,
        isSuccess: isSuccess,
    };
};
